module.exports = __webpack_public_path__ + "static/media/KUDOS KS1 SPEAKER CABLE.bac211c2.png";